import { removeWindowClass } from '@app/utils/helpers';
import axios from 'axios';
import { responseStatus } from '../constants';
import { ApiPaths } from '../helpers/api';

export const loginByAuth = async (userName: string, passWord: string) => {
  //const token = await Gatekeeper.loginByAuth(userName, passWord);
  let token = '';
  let info = '';
  const data = {
    userName: userName,
    passWord: passWord
    };

    await axios.post(ApiPaths.login.System, data)
    .then((res) => {
      if (res.data.trangThai == responseStatus.thanhCong) {
        token = res.data.duLieu.token;
        info = res.data.duLieu;
      } else {
        throw new Error(res.data.thongBao);
      }
    }).catch((err) => {
      throw err;
    });

  if (token == null || token == '') {
    throw 'Tên đăng nhập hoặc mật khẩu không đúng';
  }

  //localStorage.setItem('token', token);
  removeWindowClass('login-page');
  removeWindowClass('hold-transition');
  return info;
};

export const loginSSO = async (serviceURL: string, ticket: string) => {
    let token = '';
    let info = '';
    await axios.post(ApiPaths.login.SSO + "?service=" + serviceURL + "&ticket=" + ticket)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                token = res.data.duLieu.token;
                info = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });

    if (token == null || token == '') {
        throw 'Tên đăng nhập hoặc mật khẩu không đúng';
    }

    //localStorage.setItem('token', token);
    removeWindowClass('login-page');
    removeWindowClass('hold-transition');
    return info;
};

//export const loginByGoogle = async () => {
//  const token = await Gatekeeper.loginByGoogle();
//  localStorage.setItem('token', token);
//  removeWindowClass('login-page');
//  removeWindowClass('hold-transition');
//  return token;
//};

//export const registerByGoogle = async () => {
//  const token = await Gatekeeper.registerByGoogle();
//  localStorage.setItem('token', token);
//  removeWindowClass('register-page');
//  removeWindowClass('hold-transition');
//  return token;
//};

//export const loginByFacebook = async () => {
//  const token = await Gatekeeper.loginByFacebook();
//  localStorage.setItem('token', token);
//  removeWindowClass('login-page');
//  removeWindowClass('hold-transition');
//  return token;
//};

//export const registerByFacebook = async () => {
//  const token = await Gatekeeper.registerByFacebook();
//  localStorage.setItem('token', token);
//  removeWindowClass('register-page');
//  removeWindowClass('hold-transition');
//  return token;
//};
